import React, {Component} from 'react';
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Button,
    Row,
    Col,
    Label,
    Input,
    FormGroup,
    Card,
    CardHeader,
    CardBody
  } from 'reactstrap';

import TablaActividades from './../components/TablaActividades'; 
import Botonera from './BotoneraGuardar';
  


import Actividad from './../api/Actividad'; 

const actividad = new Actividad(); 
  

class ModalGestionActividad extends Component {

    constructor() {
        super(); 
        this.state = {
            data : [],
            nombre:'',
            descripcion:'',
            id:''
        }
    }

    
    manejaNombre = evento => {
        this.setState({nombre: evento.target.value});
    }
    manejaDescripcion = evento => {
        this.setState({descripcion: evento.target.value});
    }

    
    async componentDidMount () {

        let listadoActividades = await actividad.mostrar(); 
        this.setState({data: listadoActividades}); 

    }


    ingresarActividad = async () => {
        let nombre = this.state.nombre;
        let descripcion = this.state.descripcion;

        let resultado = await actividad.ingresar(nombre, descripcion)

        if(resultado==="ok"){console.log("ingresado")}

        let listadoActividades = await actividad.mostrar(); 
        this.setState({data: listadoActividades, nombre:'', descripcion:''}); 
        this.props.actualiza()
    }

    editarActividad = async () => {
        let {id, nombre, descripcion} = this.state;

        let resultado = await actividad.editar(id, nombre, descripcion)

        if(resultado==="ok"){console.log("editado")}

        let listadoActividades = await actividad.mostrar(); 
        this.setState({data: listadoActividades, nombre:'', descripcion:'', id:''}); 
        this.props.actualiza()
    }

    cargarEditar = (c) => {
        this.setState({id: c.id, nombre: c.nombre, descripcion: c.descripcion}); 
    }

    cancelarEditar = () => {
        this.setState({ nombre:'', descripcion:'', id:''}); 
    }
    
    eliminarActividad = async (id) => {
        let resultado = await actividad.eliminar(id)

        if(resultado==="ok"){console.log("borrado")}

        let listadoActividades = await actividad.mostrar(); 
        this.setState({data: listadoActividades}); 
        this.props.actualiza()
    }


    render(){
        const {nombre, descripcion, id, } = this.state;
        const { isOpen, toggle} = this.props; 
        return (

            <Modal  isOpen={isOpen} toggle={toggle}   backdrop="static" className="modal-grande">
                <ModalHeader  toggle={toggle} >
                    Administrador de actividades
                </ModalHeader>
                <ModalBody>      

               
                    <Card>
                        <CardHeader>Información de la actividad</CardHeader>
                        <CardBody>
                            <Row className="no-margin-bottom">
                                <Col  xl={3} lg={3} md={6} sm={12}>
                                    <FormGroup>
                                        <Label>Nombre</Label>
                                        <Input
                                            type="text"
                                            placeholder=""
                                            onChange={this.manejaNombre}
                                            value={nombre}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col  xl={9} lg={9} md={6} sm={12}>
                                    <FormGroup>
                                        <Label >Descripción</Label>
                                        <Input
                                            type="text"
                                            placeholder=""
                                            onChange={this.manejaDescripcion}
                                            value={descripcion}
                                        />
                                    </FormGroup>
                                </Col>
                                
                            </Row>
                
                        </CardBody>
                        <Botonera 
                            valor={id}
                            ingresar={this.ingresarActividad}
                            editar={this.editarActividad}
                            cancelar={this.cancelarEditar}
                        />

                    </Card>

                    <br/>

                     <TablaActividades
                        data = {this.state.data}
                        eliminar = {this.eliminarActividad}
                        editar = {this.cargarEditar}
                    />

        
      

                </ModalBody>
                <ModalFooter>
                    <Button color="primary"  onClick={toggle}>OK</Button>
                </ModalFooter>
            </Modal>

        )
    }
};

export default ModalGestionActividad;